import { RUTAS } from '@/common/components/user-menu/constants/user-profile-content'
import { resolveLegacyMenuUrl } from './legacy-menu-url.js'

/**
 * Destino del ítem "Editar perfil" del menú de usuario.
 *
 * Mientras el microfrontend de Mi perfil no esté habilitado en un ambiente, ese ambiente define
 * `VITE_LEGACY_MI_PERFIL_URL` con la URL del PHP legacy y el ítem navega ahí; sin valor válido se
 * navega a la ruta interna del shell que monta el microfrontend.
 *
 * @returns {string} URL (absoluta para el PHP legacy, o ruta interna del shell)
 */
export function resolveMiPerfilUrl() {
  return resolveLegacyMenuUrl(import.meta.env.VITE_LEGACY_MI_PERFIL_URL, RUTAS.miPerfil)
}
